<template>
	<div class="synced-group-users-action-type">
		<div class="section-title">Invitation and membership options</div>
		<AppRadioButton v-model="syncedGroupUsersActionType" :choices="syncedGroupUsersActionTypes">
			<template v-slot:label="{ item }">
				<div class="display-flex flex-column text-align-left flex-justify-center">
					<div class="label">{{ item.title }}</div>
					<div class="sub-label">{{ item.subTitle }}</div>
				</div>
			</template>
		</AppRadioButton>
	</div>
</template>

<script>
import { SYNC_USERS_ACTION_TYPE } from '@/utils/groups-const';
export default {
	name: 'ChooseSyncAction',
	components: {},
	props: {
		group: { type: Object, default: null },
		service: { type: Object },
	},
	computed: {
		serviceName() {
			return this.service?.service_name;
		},
		syncedGroupUsersActionTypes() {
			return [
				{
					title: `invite all users`,
					subTitle: 'Synced users will be invited to your workspace. Ply will send emails to all invited users.',
					value: SYNC_USERS_ACTION_TYPE.INVITE_NEW,
				},
				{
					title: `Invite all users without an email invitation`,
					subTitle: 'Synced users will be invited to your workspace. Ply will not send emails to invited users.',
					value: SYNC_USERS_ACTION_TYPE.INVITE_NEW_WITHOUT_SENDING_NOTIFICATION,
				},
				{
					title: `Do not invite users, only include existing workspace members`,
					subTitle: 'You can invite members manually and they will be automatically added to the group',
					value: SYNC_USERS_ACTION_TYPE.SYNC_EXISTING_PLY_USERS,
				},
			];
		},
	},
	async mounted() {
		if (this.group) {
			this.syncedGroupUsersActionType = this.group.synced.sync_users_action_type;
		}
	},
	watch: {
		syncedGroupUsersActionType: {
			handler(val) {
				val && this.$emit('selected-action-type', val);
			},
			immediate: true,
		},
	},
	data() {
		return {
			syncedGroupUsersActionType: SYNC_USERS_ACTION_TYPE.SYNC_EXISTING_PLY_USERS,
		};
	},
};
</script>

<style scoped lang="scss">
.synced-group-users-action-type {
	.label {
		font-size: 14px;
		color: var(--primary-font-color);
	}
	.sub-label {
		font-size: 12px;
		opacity: 0.5;
		color: var(--primary-font-color);
	}
}
</style>
